/**
 * Create Bounded Context Command
 * 
 * Command for creating new DDD Bounded Context strategic models.
 * Includes validation and business rule enforcement.
 */

import { ICommand, BaseCommand } from '@swoft/core';

export interface CreateBoundedContextPayload {
  id?: string; // Optional predefined ID
  name: string;
  description?: string;
  type?: 'core' | 'supporting' | 'generic';
  ubiquitousLanguage?: Record<string, string>;
  domainServices?: Array<{
    name: string;
    description?: string;
  }>;
  aggregates?: Array<{
    name: string;
    description?: string;
  }>;
  valueObjects?: Array<{
    name: string;
    description?: string;
  }>;
  entities?: Array<{
    name: string;
    description?: string;
  }>;
}

export class CreateBoundedContextCommand extends BaseCommand implements ICommand {
  constructor(
    public readonly domainId: string,
    public readonly payload: CreateBoundedContextPayload,
    authSessionId: string,
    initiatedByPersonId: string,
    correlationId?: string
  ) {
    super(authSessionId, initiatedByPersonId, correlationId);
  }
}